import type { ThemeOptions } from '@mui/material';

const TypographyTheme: Partial<ThemeOptions> = {
  typography: {
    fontSize: 16,
    fontWeightBold: 500,
    h1: {
      fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss03' on",
      fontSize: 28,
      fontWeight: 500,
      letterSpacing: '-0.02em',
      lineHeight: '110%',
    },
    h2: {
      fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss03' on",
      fontSize: 22,
      fontWeight: 500,
      letterSpacing: '-0.02em',
      lineHeight: '110%',
    },
    h3: {
      fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss03' on",
      fontSize: 18,
      fontWeight: 500,
      letterSpacing: '-0.02em',
      lineHeight: '110%',
    },
    h4: {
      fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss03' on",
      fontSize: 18,
      fontWeight: 400,
      letterSpacing: '-0.01em',
      lineHeight: '133%',
    },
    h5: {
      fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss03' on",
      fontSize: 16,
      fontWeight: 500,
      letterSpacing: '-0.02em',
      lineHeight: '125%',
    },
    h6: {
      fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss03' on",
      fontSize: 16,
      fontWeight: 400,
      letterSpacing: '-0.01em',
      lineHeight: '150%',
    },
    subtitle1: {
      fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss03' on",
      fontSize: 14,
      fontWeight: 400,
      letterSpacing: '0.0em',
      lineHeight: '140%',
    },
    caption: {
      fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss03' on",
      fontSize: 14,
      fontWeight: 300,
      letterSpacing: '-0.01em',
      lineHeight: '140%',
    },
    body1: {
      fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss03' on",
      fontSize: 14,
      fontWeight: 400,
      letterSpacing: '-0.01em',
      lineHeight: '140%',
    },
    body2: {
      fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss03' on",
      fontSize: 16,
      fontWeight: 300,
      letterSpacing: '-0.01em',
      lineHeight: '150%',
    },

    fontFamily: [
      'GT America',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
};

export default TypographyTheme;
